<template>
  <div class="category-bar-wrapper">
    <div class="category-bar" ref="scrollRef">
      <!-- Lobby -->
      <button
        ref="lobbyBtn"
        :class="['category-button', { active: selectedCategory === 'lobby' }]"
        @click="selectCategory('lobby')"
      >
        <img class="avatar" :src="fullImg('/public/img/lobby.svg')" alt="Lobby" />
        <span class="label"> {{ $t('home.Lobby') }}</span>
      </button>

      <!-- Rivo Originals -->
      <button
        :class="['category-button', { active: selectedCategory === 'rivo-originals' }]"
        @click="selectCategory('rivo-originals')"
      >
        <img class="avatar" :src="fullImg('/public/img/rivoor.svg')" alt="Rivo Originals" />
        <span class="label">Rivo</span>
      </button>

      <!-- Favorites -->
      <button
        v-if="hasFavorites"
        :class="['category-button', { active: selectedCategory === 'favorites' }]"
        @click="selectCategory('favorites')"
      >
        <img class="avatar" :src="fullImg('/public/img/star.svg')" alt="Favorites" />
        <span class="label"> {{ $t('home.Favorites') }}</span>
      </button>

      <!-- Dynamic Categories -->
      <button
        v-for="category in categories"
        :key="category._id"
        :ref="setButtonRef(category._id)"
        :class="['category-button', { active: selectedCategory === category.slug }]"
        @click="selectCategory(category.slug)"
      >
        <img class="avatar" :src="fullImg(category.img)" :alt="category.name" />
        <span class="label">{{ category.name }}</span>
      </button>

      <div
        class="underline"
        :style="{ left: underlineStyle.left + 'px', width: underlineStyle.width + 'px' }"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeCategory',
  props: {
    categories: {
      type: Array,
      required: true
    },
    selectedCategory: {
      type: String,
      default: 'lobby'
    },
    hasFavorites: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      underlineStyle: { left: 0, width: 0 },
      buttonRefs: {},
      isMobile: false
    };
  },
  watch: {
    selectedCategory() {
      this.$nextTick(this.updateUnderline);
    }
  },
  mounted() {
    this.isMobile = window.innerWidth <= 1024;
    this.updateUnderline();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.isMobile = window.innerWidth <= 1024;
    },
    selectCategory(id) {
      this.$emit('update:selectedCategory', id);
    },
    updateUnderline() {
      const id = this.selectedCategory || 'lobby';
      const btn = this.buttonRefs[id] || this.$refs.lobbyBtn;
      if (btn) {
        this.underlineStyle.left = btn.offsetLeft;
        this.underlineStyle.width = btn.offsetWidth;
      }
    },
    setButtonRef(id) {
      return (el) => {
        if (el) this.buttonRefs[id] = el;
      };
    },
    fullImg(path) {
      if (!path) return '';
      if (path.startsWith('http')) return path;
      return process.env.VUE_APP_BACKEND_URL + path;
    }
  }
};
</script>

<style scoped>
.category-bar-wrapper {
  width: 100%;
  position: relative;
}


.category-bar {
  width: 100%;
   
  display: flex;
  overflow-x: auto;
       gap: 7px;
  border-radius: 5px;
  margin-bottom: 15px;
        
  position: relative;
  scrollbar-width: none;
}
.category-bar::-webkit-scrollbar {
  display: none;
}

.category-button {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0.4rem 0.8rem;
  background: var(--background2);
  border-radius: 10px;
  color: white;
   padding-top: 10px;
   padding-bottom: 10px;
  border: none;
  cursor: pointer;
  font-family: var(--font-header);
  font-weight: 600;
  font-size: 13px;
}
.category-button .avatar {
  width: 20px;
  height: 20px;
  object-fit: contain;
}
.category-button.active {
  color: #fff;
  background: var(--active-button);
}

@media (max-width: 1024px) {
  .category-button {
   
    font-size: 12px;
  }
  .category-button .avatar {
    width: 20px;
    height: 20px;
  }
  .category-bar-wrapper {
    padding-left: 10px;
    padding-right: 10px;
    z-index: 1;
    margin-top: 10px;
  }
 

  .category-bar {
  width: 100%;
  padding-top: 5px;
  padding: 0;
  display: flex;
  overflow-x: auto;
 
  border-radius: 8px;
  margin-bottom: 15px;
  position: relative;
  scrollbar-width: none;
}
}
</style>
